import { initFocusTrap } from "../../js/focus-trap.24d9780813f9.js";

const CONSENT_COOKIE_NAME = "consumer_provider_consent";

class PetDisclaimerModal extends HTMLElement {
  focusTrap = null;

  connectedCallback() {
    this.modal = this.querySelector("dialog");
    const cookiePreferences = JSON.parse(
      document.getElementById("cookie-preferences").textContent,
    );
    this.useConsentCookie =
      !cookiePreferences || cookiePreferences["allow_functional_cookies"];
    if (this.hasConsentCookie()) {
      this.remove();
      return;
    }
    this.showModal();
    this.focusTrap = initFocusTrap(this.modal);
    // this is important in the case when user clicks the escape key
    this.modal.addEventListener("close", this.enablePageScrolling);
    this.querySelectorAll("[data-close-disclaimer]").forEach((element) => {
      element.addEventListener("click", this.closeModal);
    });
    // this is for modals with forms using htmx
    this.addEventListener("tqc-close-disclaimer", this.closeModal);
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        if (this.hasConsentCookie()) {
          this.remove();
          return;
        }
        this.showModal();
      }
    });

    this.modal.addEventListener("htmx:afterSwap", () => {
      this.setupAttestationFormValidation();
    });
  }

  hasConsentCookie = () => {
    const consentCookieOnBrowser = document.cookie
      .split("; ")
      .some((row) => row.startsWith(`${CONSENT_COOKIE_NAME}=`));

    // Check if user has already consented
    if (this.useConsentCookie && consentCookieOnBrowser) {
      return true;
    }
    return false;
  };

  setConsentCookie = () => {
    // Set cookie with 1 year expiration
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 1);
    document.cookie = `${CONSENT_COOKIE_NAME}=true; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`;
  };

  disconnectedCallback() {
    if (this.focusTrap) {
      this.focusTrap.destroy();
    }
  }

  showModal = () => {
    this.modal.showModal();
    this.disablePageScrolling();
  };

  isConsentCookieAllowed = () => {
    const isCookieAllowedCookie = this.modal.getAttribute(
      "data-is-cookie-allowed-cookie",
    );
    if (!isCookieAllowedCookie) {
      return true;
    }
    const match = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${isCookieAllowedCookie}=`));
    return match && match.split("=")[1] === "true";
  };

  closeModal = () => {
    if (this.useConsentCookie) {
      this.setConsentCookie();
    }
    this.modal.close();
    this.enablePageScrolling();
    document.body.focus();
  };

  disablePageScrolling = () => {
    document.querySelector("body").style.overflow = "hidden";
  };

  enablePageScrolling = () => {
    document.querySelector("body").style.overflow = "";
  };

  setupAttestationFormValidation = () => {
    const form = this.querySelector("#provider-attestation-form");
    if (!form) return;

    const submitButton = form.querySelector("button[hx-post]");

    const validateForm = () => {
      submitButton.disabled = !form.checkValidity();
    };

    form.addEventListener("input", validateForm);
  };
}

window.customElements.define("pet-disclaimer-modal", PetDisclaimerModal);
